<i18n src="../../locales/lang.json"></i18n>
<template>  
  <div class="container-fluid px-0">
    

    <form id="calanderImportForm" name="calanderImportForm" class="login-formx form-validate" action="index.html" onsubmit="return false">
      <div class="row">
        <div class="col-12">
          {{$store.translate('import_calander')}}
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-4">
          {{ $store.translate('country')}}
        </div>
        <div class="col-4 custom-form-label">
          {{ $store.translate('year')}}
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-4">
          <select required v-model="country" class="form-control" v-bind:id="'select_country_' +  getId()">
            <option value="">{{ $t('country') }}</option>
            <option value="Norway">Norway</option>
            <option value="Brazil">Brazil</option>
            <option value="Sweden">Sweden</option>
          </select>
        </div>
        <div class="col-4">
          <select required v-model="year" class="form-control" v-bind:id="'select_year_' +  getId()">
            <option value="-1">{{ $t('year') }}</option>
            <option v-bind:value="year" v-for="year in years">{{ year }}</option>
          </select>
        </div>
        <div class="col-4">
          <button type="submit" class="btn skin primary-button" @click="importCalander">{{$t('import')}}</button>
        </div>
      </div>
    </form>

  </div>
</template>

<script>  
  var msg = "";
  export default {
    name: "import-calander-holidays",
    components: {
      
    },
    props: {
    },
    data() {
      return {        
        msg,
        country: '',
        year: '',
        years: [new Date().getFullYear() - 1, new Date().getFullYear(), new Date().getFullYear()+1]
      };
    },
    computed: {

    },

    methods: {
      getId() {
        return this._uid;
      },
      async importCalander() {

      

        if (!$('#calanderImportForm').valid())
          return false;
        var request = {
          countryname: $('#select_country_' + this.getId()).val(),
          year: $('#select_year_' + this.getId()).val(),
          
        };

        try {
          var response = await this.$http.post(
            '/api/Calender/ImportCalender?country=' + this.country + '&year=' + this.year ,
            request
          ).then(async response => {
            alert('Calendar imported successfully !!')
          });

        } catch (err) {
          alert(err);
        }
      },
    },
    mounted() {
      _componentValidation('#calanderImportForm');
      //this.activateTab("procedure-detail-editPanel");

    },
    created: function () {

    },
    watch: {
    },
  };

</script>

<style scoped>

  .nav-item {
  }

  .nav-link.active::before {
  }

  .nav-link {
    padding-left: 15px;
    padding-right: 15px;
  }

    .nav-link.active {
      /*background-color: white !important;*/
    }

  .tab-content {
    /*background-color: white !important;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/calander/import-calander-holidays.vue